import React, { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

import { RequireAuth } from '../hoc'
import { lazyRetry } from '../lazy-retry'
import { ROUTES } from '../routes-list'

const EmbedChat = lazy(() => lazyRetry(() => import('../../embed/chat'), 'EmbedChat'))
const EmbedShipmentRedirect = lazy(() =>
  lazyRetry(() => import('../../embed/shipment-redirect'), 'EmbedShipmentRedirect')
)
const EmbedMap = lazy(() => lazyRetry(() => import('../../embed/map'), 'EmbedMap'))

export const embedRoutes = (): RouteObject[] => {
  return [
    {
      element: (
        <RequireAuth>
          <EmbedChat />
        </RequireAuth>
      ),
      path: `${ROUTES.EMBED_CHAT}/:shipmentID`
    },
    {
      element: (
        <RequireAuth>
          <EmbedMap />
        </RequireAuth>
      ),
      path: `${ROUTES.EMBED_MAP}/:shipmentID`
    },
    {
      element: (
        <RequireAuth>
          <EmbedShipmentRedirect />
        </RequireAuth>
      ),
      path: `:workspace_name${ROUTES.EMBED_CHAT}/:externalShipmentID`
    },
    {
      element: (
        <RequireAuth>
          <EmbedShipmentRedirect />
        </RequireAuth>
      ),
      path: `:workspace_name${ROUTES.EMBED_MAP}/:externalShipmentID`
    }
  ]
}
